module.exports = __webpack_public_path__ + "static/media/ini2-180w.6ae9997a.jpg";